<template>
  <div class="wrapper">
    <BPMNNodeBase :item="item" @updateName="updateName"/>
    <div class="container-fluid">
      <div class="form-group">
        <label>Service</label>
        <input type="text" class="form-control" disabled v-model="serviceKey"/>
      </div>
      <div class="form-group">
        <label>Controller</label>
        <input type="text" class="form-control" disabled v-model="controller"/>
      </div>
      <div class="form-group">
        <label>Aktion</label>
        <input type="text" class="form-control" disabled v-model="method"/>
      </div>
      <button @click="openServiceSelector" class="btn btn-primary">Service wählen...</button>
      <hr/>
      <div class="form-group">
        <label>Ergebnis Variable</label>
        <input type="text" class="form-control" v-model="variable" @blur="updateOutVar" placeholder="Prozessvariable optional"/>
      </div>
      <div class="form-group">
        <label>Ergebnis Datei</label>
        <input type="text" class="form-control" v-model="outFile" @blur="updateOutFile" placeholder="Ausgabedatei optional"/>
      </div>
      <div v-for="(p,key) in serviceEntry.input" :key="key" class="form-group">
        <label>{{ p.name }}</label>
        <div class="input-group">
          <input :placeholder="p.dataType" type="text" class="form-control" v-model="params[p.name]" @blur="updateParams"/>
          <div class="input-group-append">
            <button v-if="!p.dataType.startsWith('java')" @click="openParamEditor(p.name)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
          </div>
        </div>
        <b-form-text v-if="p.hint">{{ p.hint }}</b-form-text>
      </div>
    </div>
    <b-modal id="serviceSelector">
      <BFlowRemoteServiceSelector :registry="serviceRegistry" @selected="updateServiceSelection"/>
    </b-modal>
    <b-modal id="typedParam" @ok="updateParamObject">
      <BFlowTypedParamEditor ref="typedParam" :data="editParamData" :dataType="editParamType"/>
    </b-modal>
  </div>
</template>

<script>
import bpmn from '@/modules/bpmn.js'
import xmlutils from '@/modules/xmlutil.js'
import BPMNNodeBase from './BPMNNodeBase.vue'
import remoteservices from '@/modules/remoteservices.js'
import BFlowRemoteServiceSelector from '../digitalfirm/BFlowRemoteServiceSelector.vue'
import BFlowTypedParamEditor from '../digitalfirm/BFlowTypedParamEditor.vue'

export default {
  props: ["item"],
  components: {
    BPMNNodeBase,
    BFlowRemoteServiceSelector,
    BFlowTypedParamEditor
  },
  data() {
    return {
      editParamType: { "attrs": [] },
      editParamData: {},
      serviceKey: '',
      serviceKeyXml: false,
      controller: '',
      controllerXml: false,
      method: '',
      methodXml: false,
      variable: '',
      variableXml: false,
      outFile: '',
      outFileXml: false,
      serviceEntry: {},
      serviceRegistry: {},
      serviceDataTypes: {},
      paramsXml: false,
      params: {},
      paramId: '',
    }
  },
  mounted() {
    var self = this;

    remoteservices.datatypes().then(function(data) {
      self.serviceDataTypes = data;
    }).catch (err => {
      console.error(err);
    });

    // load modules registry
    remoteservices.registry().then(function(data) {
      console.log('registry',data);
      self.serviceRegistry = data;
      self.parseItem();
    }).catch (err => {
      console.error(err);
    });
  },
  methods: {
    updateName(e) {
      this.$emit('updateName',e);
    },
    openServiceSelector() {
      this.$bvModal.show('serviceSelector');
    },
    openParamEditor(key) {
      console.log(key);
      if (this.serviceDataTypes) {
        var dataType = this.serviceDataTypes[this.serviceEntry.input[key].dataType];
        console.log(dataType);
        if (dataType) {
          this.editParamType = dataType;
          this.editParamData = this.params[key] || {};
          for (var k in this.editParamData) {
            console.log(k,typeof this.editParamData[k]);
            if (typeof this.editParamData[k] === 'object') {
              this.editParamData[k + '_parsed'] = true;
              this.editParamData[k] = JSON.stringify(this.editParamData[k]);
            }
          }
          this.paramId  = key;

          this.$bvModal.show('typedParam');
        }
      } else {
        console.warn('No data types from service registry given.')
      }
    },
    updateParamObject() {
      console.log('param object update');
      console.log(this.paramId,this.editParamData)
      this.params[this.paramId] = JSON.parse(JSON.stringify(this.editParamData));
      this.updateParams();
      this.$forceUpdate();
    },
    updateParams() {
      if (!this.paramsXml) {
        this.paramsXml = bpmn.newExpressionChild();
        this.paramsXml.attributes.name.value = 'params';
        this.extensions.children.push(this.paramsXml);
      }
      this.paramsXml.children[0].children[0].content = JSON.stringify(this.params);
    },
    updateOutVar() {
      if (!this.variableXml) {
        this.variableXml = bpmn.newStringFieldChild();
        this.variableXml.attributes.name.value = 'variable';
        this.extensions.children.push(this.variableXml);
      }
      this.variableXml.children[0].children[0].content = this.variable;
    },
    updateOutFile() {
      if (!this.outFileXml) {
        this.outFileXml = bpmn.newStringFieldChild();
        this.outFileXml.attributes.name.value = 'outFile';
        this.extensions.children.push(this.outFileXml);
      }
      this.outFileXml.children[0].children[0].content = this.outFile;
    },
    updateServiceSelection(key,ctrl,method,service) {
      if (!this.serviceKeyXml) {
        this.serviceKeyXml = bpmn.newStringFieldChild();
        this.serviceKeyXml.attributes.name.value = 'service';
        this.extensions.children.push(this.serviceKeyXml);
      }
      this.serviceKeyXml.children[0].children[0].content = key;
      this.serviceKey = key;

      if (!this.controllerXml) {
        this.controllerXml = bpmn.newStringFieldChild();
        this.controllerXml.attributes.name.value = 'controller';
        this.extensions.children.push(this.controllerXml);
      }
      this.controllerXml.children[0].children[0].content = ctrl;
      this.controller = ctrl;

      if (!this.methodXml) {
        this.methodXml = bpmn.newStringFieldChild();
        this.methodXml.attributes.name.value = 'method';
        this.extensions.children.push(this.methodXml);
      }
      this.methodXml.children[0].children[0].content = method;
      this.method = method;

      this.serviceEntry = service;
      console.log(this.item);
      this.$bvModal.hide('serviceSelector');
    },
    parseItem() {
      // check at least childrens
      if (!this.item.children) { this.item.children = []; }

      // get extension child
      this.extensions = xmlutils.jsonxmlchild(this.item,'extensionElements');

      // add if not present
      if (!this.extensions) {
        this.extensions = bpmn.newExtensions();
        this.item.children.push(this.extensions);
      } else if (!this.extensions.children) {
        this.extensions.children = [];
      }

      for (var i in this.extensions.children) {
        var sub = this.extensions.children[i];
        if (sub.localName == 'field') {
          console.log('check fields',sub);
          if (sub.attributes.name.value == 'service') {
            this.serviceKeyXml = sub;
            this.serviceKey    = sub.children[0].children[0].content;
            console.log('service',this.sender);
          } else if (sub.attributes.name.value == 'controller') {
            this.controllerXml = sub;
            this.controller    = sub.children[0].children[0].content;
            console.log('receiver',this.receiver);
          } else if (sub.attributes.name.value == 'method') {
            this.methodXml = sub;
            this.method    = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'variable') {
            this.variableXml = sub;
            this.variable    = sub.children[0].children[0].content;
          } else if (sub.attributes.name.value == 'params') {
            this.paramsXml = sub;
            var str = sub.children[0].children[0].content;
            if (str && str.startsWith('{')) {
              this.params    = JSON.parse(sub.children[0].children[0].content);
            } else {
              console.warn('parameter not correct value: ' + str);
              this.params    = {};
            }
            console.log(sub.children[0].children[0].content);

          } else if (sub.attributes.name.value == 'outFile') {
            this.outFileXml = sub;
            this.outFile    = sub.children[0].children[0].content;
          }
        }
      } // check given extensions

      // check service entry for ui
      if (this.serviceKey) {
        this.serviceEntry = this.serviceRegistry[this.serviceKey][this.controller][this.method];
      }

    } // parseItem
  }
}
</script>
